import i18n from "@/i18n";

export default [
  { id: "provide_as_inventory_code", name: i18n.t("integrations.inventory-blockings.attribute.provide_as_inventory_code") },
  { id: "order_id", name: i18n.t("integrations.inventory-blockings.attribute.order_id") }
];
